module.exports = __webpack_public_path__ + "img/bowel-cancer-uk.9977d3b3.png";